import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { BonusWinPopup, RaffleInitResponse } from "@/apps/raffle/types";

export const getRaffleDataKey = (yandexId: string, bonusId?: string) =>
  `${yandexId}:${bonusId ?? "init"}`;

type RaffleDataState = {
  raffleByKey: Record<string, RaffleInitResponse | null>;
  bonusWinPopup: BonusWinPopup | null;
  getRaffle: (
    yandexId: string | null,
    bonusId?: string
  ) => RaffleInitResponse | null;
  setRaffle: (
    yandexId: string,
    bonusId: string | undefined,
    raffle: RaffleInitResponse | null
  ) => void;
  clearRaffle: (yandexId: string, bonusId?: string) => void;
  setBonusWinPopup: (popup: BonusWinPopup | null) => void;
  clearBonusWinPopup: () => void;
};

export const useRaffleDataStore = create<RaffleDataState>()(
  persist(
    (set, get) => ({
      raffleByKey: {},
      bonusWinPopup: null,
      getRaffle: (yandexId, bonusId) =>
        yandexId
          ? get().raffleByKey[getRaffleDataKey(yandexId, bonusId)] ?? null
          : null,
      setRaffle: (yandexId, bonusId, raffle) =>
        set((state) => ({
          raffleByKey: {
            ...state.raffleByKey,
            [getRaffleDataKey(yandexId, bonusId)]: raffle,
          },
        })),
      clearRaffle: (yandexId, bonusId) =>
        set((state) => {
          const { [getRaffleDataKey(yandexId, bonusId)]: _removed, ...raffleByKey } =
            state.raffleByKey;

          return { raffleByKey };
        }),
      setBonusWinPopup: (popup) =>
        set({
          bonusWinPopup: popup,
        }),
      clearBonusWinPopup: () =>
        set({
          bonusWinPopup: null,
        }),
    }),
    {
      name: "raffle-data:store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        raffleByKey: state.raffleByKey,
        bonusWinPopup: state.bonusWinPopup,
      }),
    }
  )
);
